import { render, staticRenderFns } from "./version.vue?vue&type=template&id=f62996dc&scoped=true&"
import script from "./version.vue?vue&type=script&lang=js&"
export * from "./version.vue?vue&type=script&lang=js&"
import style0 from "./version.vue?vue&type=style&index=0&id=f62996dc&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f62996dc",
  null
  
)

export default component.exports